import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import CreateContainer from 'containers/forms/capabilityGroups/CreateCapabilityGroupContainer';

import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import PageTitle from 'hoc/PageTitle';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS, CAPABILITY_GROUP_CREATE } from 'constants/capabilities';

const CreateCapabilityGroupPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/capability-groups">&lt; Capability Groups</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <CreateContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Create Capability Group', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS, CAPABILITY_GROUP_CREATE] }),
)(CreateCapabilityGroupPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/capabilityGroups/CreateCapabilityGroups.js